import React from "react";
import { Save, X, Loader } from "lucide-react";

/**
 * Modern high-contrast action bar for New Activity Form
 */
const FormActions = ({ onSave, onCancel, saving, isEditing }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 sm:relative bg-white/95 backdrop-blur border-t sm:border-t-0 border-slate-200 p-4 sm:p-0 z-40 shadow-lg sm:shadow-none">
      <div className="max-w-6xl mx-auto flex items-center justify-end gap-3">
        {/* Cancel Button */}
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className="
            flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-6 py-2.5
            bg-white text-slate-700 font-semibold text-sm
            border border-slate-300 rounded-xl hover:bg-slate-100 hover:text-slate-900
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-all duration-200 shadow-sm
            focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2
          "
        >
          <X className="w-4 h-4" />
          Cancel
        </button>

        {/* Save/Update Button */}
        <button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="
            flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-7 py-2.5
            bg-slate-900 text-white font-semibold text-sm
            rounded-xl hover:bg-slate-800 active:bg-slate-950
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-all duration-200 shadow-sm hover:shadow
            focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2
          "
        >
          {saving ? (
            <>
              <Loader className="w-4 h-4 animate-spin text-white" />
              {isEditing ? "Updating..." : "Submitting..."}
            </>
          ) : (
            <>
              <Save className="w-4 h-4" />
              {isEditing ? "Update Entry" : "Submit Activity"}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FormActions;
